export default {"src":"/_next/static/media/github.63fcb863.svg","height":512,"width":512};